import { Box, Typography, Button } from "@mui/material";
import Iconify from "../../components/iconify/Iconify";

const EmptyVariantState = () => {
  return (
    <Box
      sx={{
        textAlign: "center",
        py: 3,
        px: 4,
        border: "1px dashed #ccc",
        borderRadius: 2,
        backgroundColor: "#fafafa",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
      }}
    >
      <Iconify icon="mdi:tag-plus-outline" width={50} height={50} />
      <Typography variant="h6" gutterBottom>
        No Variants Added Yet
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Variants allow you to sell this item in different sizes, colors, or
        other attributes. Start by selecting attributes and adding your first
        variant.
      </Typography>
    </Box>
  );
};

export default EmptyVariantState;
